import { render, staticRenderFns } from "./CompanyLimits.vue?vue&type=template&id=d2efbe4a"
import script from "./CompanyLimits.vue?vue&type=script&lang=js"
export * from "./CompanyLimits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports